<style scoped lang="scss">

</style>

<template>
    <div>
        <slot />
        <div class="uk-margin-small-top" v-if="showError">
            <div class="uk-text-danger" v-for="error in fieldErrors"> {{ error }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ValidatedSection",
        props: {
            errors: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            field: {
                type: String,
                default: null,
            },
            fields: {
                type: Array,
                default: null,
            }
        },
        data() {
            return {

            }
        },
        created() {
            if(this.fields === null) {
                this.fields = [];
            }
            if(this.field && !this.fields.includes(this.field)) {
                this.fields.push(this.field);
            }
        },
        computed: {
            fieldErrors() {
                let errorStrings = [];
                if(this.errors === null) return errorStrings;
                _.each(this.fields, field => {
                    if(this.errors[field] !== null) {
                        _.each(this.errors[field], err => errorStrings.push(err));
                    }
                })
                return errorStrings;
            },
            showError() {
                let shouldShow = false;
                _.each(this.fields, field => {
                    if(this.errors[field] !== null) {
                        shouldShow = true;
                    }
                })
                return shouldShow;
            }
        }
    }
</script>
